// extracted by mini-css-extract-plugin
module.exports = {"modal-dialog":"t_cf","modalDialog":"t_cf","modal-title":"t_cg","modalTitle":"t_cg","modal-subtitle":"t_ch","modalSubtitle":"t_ch"};